import { makeRuntime as f } from "@arcgis/lumina";
import { isServer as g } from "lit-html/is-server.js";
/*! All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
v3.0.3 */
const l = "calcite-mode-auto", u = "calcite-mode-dark", h = "calcite-mode-light", D = {
  autoMode: l,
  darkMode: u,
  lightMode: h,
  rtl: "calcite--rtl",
  calciteAnimate: "calcite-animate",
  calciteAnimateInUp: "calcite-animate__in-up",
  calciteAnimateInDown: "calcite-animate__in-down",
  calciteAnimateInRight: "calcite-animate__in-right",
  calciteAnimateInLeft: "calcite-animate__in-left"
}, M = {
  filter: 250,
  nextTick: 0,
  resize: 150,
  reposition: 100
};
function r() {
  const { classList: t } = document.body, i = window.matchMedia("(prefers-color-scheme: dark)").matches, a = () => t.contains(u) || t.contains(l) && i ? "dark" : "light", c = (e) => document.body.dispatchEvent(new CustomEvent("calciteModeChange", { bubbles: !0, detail: { mode: e } })), s = (e) => {
    o !== e && c(e), o = e;
  };
  let o = a();
  c(o), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (e) => s(e.matches ? "dark" : "light")), new MutationObserver(() => s(a())).observe(document.body, {
    attributes: !0,
    attributeFilter: ["class"]
  });
}
const n = globalThis.calciteConfig, _ = n?.focusTrapStack || [], E = n?.logLevel || "info", d = "3.0.3", p = "2025-02-19", b = "0b0b89f59";
function v() {
  if (n && n.version)
    return;
  console.info(`Using Calcite Components ${d} [Date: ${p}, Revision: ${b}]`);
  const t = n || globalThis.calciteConfig || {};
  Object.defineProperty(t, "version", {
    value: d,
    writable: !1
  }), globalThis.calciteConfig = t;
}
const m = () => !g && typeof navigator < "u" && typeof window < "u" && typeof location < "u" && typeof document < "u" && window.location === location && window.document === document;
function C() {
  return navigator.userAgentData;
}
function L() {
  if (!m())
    return "";
  const t = C();
  return t?.brands ? t.brands.map(({ brand: i, version: a }) => `${i}/${a}`).join(" ") : navigator.userAgent;
}
function w() {
  m() && (document.readyState === "interactive" ? r() : document.addEventListener("DOMContentLoaded", () => r(), { once: !0 })), v();
}
w();
const A = f({ defaultAssetPath: "https://js.arcgis.com/calcite-components/3.0.3/", hydratedAttribute: "calcite-hydrated" }), { customElement: S, getAssetPath: T, setAssetPath: I } = A;
export {
  D as C,
  M as D,
  L as a,
  S as c,
  _ as f,
  T as g,
  m as i,
  E as l,
  A as r,
  I as s
};
